import { useStyles } from './alertModal.styles';
import { CustomModal } from '../../../components/customModal';
import { AlertModalPropsType } from './primaryAlertModal';

export const SignPageModal = (props: AlertModalPropsType) => {
  const {
    opened, onClose, onPrimaryBtnClick, onSecondaryBtnClick, title, description, pBtnText, sBtnText, className,
  } = props;
  const { classes, cx } = useStyles();
  return (
    <CustomModal opened={opened} onClose={onClose} className={cx(classes.modalWrapper, className)}>
      <div className={classes.modalTextContainer}>
        <h2 className={classes.modalHeader}>{title}</h2>
        <p className={classes.modalDescription}>{description}</p>
      </div>
      <div
        className={classes.modalBtnContainer}
      >
        {sBtnText && (
          <button
            type="button"
            className={cx(classes.modalBtn, classes.modalBtnSec)}
            onClick={onSecondaryBtnClick}
          >
            {sBtnText}
          </button>
        )}
        {pBtnText && (
          <button
            type="button"
            className={classes.modalBtn}
            onClick={onPrimaryBtnClick}
          >
            {pBtnText}
          </button>
        )}
      </div>
    </CustomModal>
  );
};

SignPageModal.defaultProps = {
  onPrimaryBtnClick: () => {},
  onSecondaryBtnClick: () => {},
  pBtnText: '',
  sBtnText: '',
  className: null,
};

export default SignPageModal;
